export const ANATOMY_TYPE_1_OPTIONS = ["Tricuspid", "Bicuspid", "VIV", "TAV-TAV"];

export const ANATOMY_TYPE_2_LEGACY = {
  "Bicuspid Type 0": "Type 0",
  "Bicuspid | Type I | R-L Fusion": "Type I | R-L Fusion",
  "Bicuspid | Type I | N-R Fusion": "Type I | N-R Fusion",
};

export const ANATOMY_TYPE_2_BY_TYPE_1 = {
  Bicuspid: [
    "Type 0",
    "Type I | R-L Fusion",
    "Type I | N-R Fusion",
  ],
  VIV: ["Stented", "Stentless/Sutureless"],
  "TAV-TAV": ["Balloon Expanding Valve Failure", "Self Expanding Valve Failure"],
};

export const ANATOMY_TYPE_3_BY_TYPE_2 = {
  Stented: ["Medtronic", "Edwards", "Abbott", "Meril", "NA/Others"],
  "Stentless/Sutureless": ["Corcym", "NA/Others"],
  "Balloon Expanding Valve Failure": ["Meril", "Edwards", "NA/Others"],
  "Self Expanding Valve Failure": [
    "Medtronic",
    "Abbott",
    "Boston Scientific",
    "SMT",
    "Microport",
    "Allegra",
    "NA/Others",
  ],
};

export const needsAnatomyType2 = (type1) => Boolean(type1) && type1 !== "Tricuspid";

export const needsAnatomyType3 = (type1) => type1 === "VIV" || type1 === "TAV-TAV";

export const getAnatomyType2Options = (type1) => ANATOMY_TYPE_2_BY_TYPE_1[type1] ?? [];

export const normalizeAnatomyType2 = (type2) => {
  const value = String(type2 ?? "").trim();
  if (!value) return "";
  return ANATOMY_TYPE_2_LEGACY[value] ?? value;
};

export const getAnatomyType3Options = (type2) => ANATOMY_TYPE_3_BY_TYPE_2[type2] ?? [];

export const validateAnatomyTypes = ({ anatomy_type_1, anatomy_type_2, anatomy_type_3 }) => {
  if (!anatomy_type_1) return "Select an anatomy type";
  if (needsAnatomyType2(anatomy_type_1) && !anatomy_type_2) return "Select anatomy type 2";
  if (needsAnatomyType3(anatomy_type_1) && !anatomy_type_3) return "Select anatomy type 3";
  return null;
};

export const buildAnatomyPayload = ({ anatomy_type_1, anatomy_type_2, anatomy_type_3 }) => {
  const payload = { anatomy_type_1 };
  if (needsAnatomyType2(anatomy_type_1) && anatomy_type_2) {
    payload.anatomy_type_2 = normalizeAnatomyType2(anatomy_type_2);
  }
  if (needsAnatomyType3(anatomy_type_1) && anatomy_type_3) {
    payload.anatomy_type_3 = anatomy_type_3;
  }
  return payload;
};

export const anatomyFromExtractDetails = (details) => {
  if (!details) return null;

  const type1 = String(details.anatomy_type_1 ?? "").trim();
  if (!type1 || !ANATOMY_TYPE_1_OPTIONS.includes(type1)) return null;

  const result = { anatomy_type_1: type1 };

  const type2 = normalizeAnatomyType2(details.anatomy_type_2);
  if (type2) {
    const type2Options = getAnatomyType2Options(type1);
    if (!type2Options.length || type2Options.includes(type2)) {
      result.anatomy_type_2 = type2;
    }
  }

  const type3 = String(details.anatomy_type_3 ?? "").trim();
  if (type3 && needsAnatomyType3(type1) && result.anatomy_type_2) {
    const type3Options = getAnatomyType3Options(result.anatomy_type_2);
    if (!type3Options.length || type3Options.includes(type3)) {
      result.anatomy_type_3 = type3;
    }
  }

  return result;
};

/** Anatomy types from patient details (listing and detail). */
export const formatPatientAnatomyTypes = (patient) => {
  const details = patient?.anatomyDetails ?? patient?.anatomy_details;
  if (!details) return "";
  return [details.anatomy_type_1, normalizeAnatomyType2(details.anatomy_type_2) || details.anatomy_type_2, details.anatomy_type_3]
    .map((v) => String(v ?? "").trim())
    .filter(Boolean)
    .join(" · ");
};
